/* Product cards - Element Packaging, W-63, 8 October 2026 (v2). Works with snippets/el-card.liquid.
   Grid view (option A): joined counter + Add, price ladder highlight, nudge after first use, matching lid add.
   Per-piece and inc VAT figures follow the highlighted rung; size buttons (variants) swap prices and case size.
   List view (option C): steppers start at 0 and a bar adds every chosen line in one go.
   Multi-case rates: 3+ cases 15%, 10+ cases 19.25%, mixed across products tagged tier-pricing
   (automatic discounts). Prices in data attributes are ex VAT pence. */
(function () {
  'use strict';
  if (window.__elCard) return;
  window.__elCard = true;

  var R3 = 0.85, R10 = 0.8075;
  var inCart = 0, inCart10 = 0, tagCache = {};

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function fmt(p) { return '£' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function plural(n, unit) { return n + ' ' + unit + (n === 1 ? '' : 's'); }
  function setText(el, t) { if (el.textContent !== t) el.textContent = t; }
  function isList(el) { return !!el.closest('.productgrid-listview'); }
  function exv(p) { return Math.round(p / 1.2); }
  function rungInc(p, m) { return m === 10 ? Math.round(p * R10) : m === 3 ? Math.round(p * R3) : p; }
  function penceEach(ex, pcs) {
    if (!(pcs > 0) || !(ex > 0)) return '';
    var t = Math.round(ex * 10 / pcs);
    return t < 1000 ? Math.floor(t / 10) + '.' + (t % 10) + 'p each' : '£' + (ex / pcs / 100).toFixed(2) + ' each';
  }
  function qtyOf(card) { var i = $('[data-el-qty]', card); return Math.max(0, parseInt(i && i.value, 10) || 0); }

  function nudgeText(card) {
    if (card.dataset.tier !== 'true') return '';
    var q = Math.max(1, qtyOf(card));
    var no10 = card.dataset.no10 === 'true';
    var t = q + inCart, t10 = q + inCart10;
    if (t < 3) {
      var need = 3 - t;
      return (inCart > 0 ? inCart + ' in your basket - add ' : 'Add ') + need + ' more case' + (need === 1 ? '' : 's') + ' (any mix) to save 15%';
    }
    if (!no10 && t10 < 10) {
      var s = '15% multi-case saving applies';
      if (10 - t10 <= 4) s += ' - ' + (10 - t10) + ' more for 19.25%';
      return s;
    }
    return (no10 ? '15%' : '19.25%') + ' multi-case saving applies';
  }

  function render(card) {
    var q = qtyOf(card);
    var unit = card.dataset.unit || 'case';
    var label = $('[data-el-add-label]', card);
    var add = $('[data-el-add]', card);
    if (label && !add.classList.contains('is-done')) setText(label, 'Add');
    if (add && !add.classList.contains('is-done')) add.disabled = q < 1;
    var body = card.closest('[data-el-card-body]');
    var ladder = body && $('[data-el-ladder].has-tiers', body);
    var pick = 1;
    if (ladder) {
      var tt = Math.max(1, q) + inCart, rungs = $$('[data-min]', ladder);
      rungs.forEach(function (r) { var m = +r.dataset.min; if (tt >= m && m > pick) pick = m; });
      rungs.forEach(function (r) { r.classList.toggle('is-on', +r.dataset.min === pick); });
    }
    var p = body ? +body.dataset.price : 0;
    if (p > 0) {
      var inc = rungInc(p, pick), eachEl = $('[data-el-each]', body), incEl = $('[data-el-inc]', body);
      if (eachEl) { var et = penceEach(exv(inc), +body.dataset.pcs); if (et) setText(eachEl, et + (pick > 1 ? ' at ' + pick + '+' : '')); }
      if (incEl) setText(incEl, fmt(inc));
    }
    var n = $('[data-el-nudge]', card);
    if (n && !n.dataset.lock && card.dataset.touched) {
      var txt = nudgeText(card);
      setText(n, txt.charAt(0).toUpperCase() + txt.slice(1));
      if (n.hidden !== !txt) n.hidden = !txt;
    }
    card.classList.toggle('is-picked', q > 0);
  }
  function renderAll() { $$('[data-el-card]').forEach(render); renderBar(); }

  /* ---------- basket ---------- */
  function refreshHeader(c) {
    $$('[data-header-cart-count]').forEach(function (el) {
      el.setAttribute('data-header-cart-count', c.item_count > 0 ? String(c.item_count) : '');
      el.classList.toggle('visible', c.item_count > 0);
    });
    try { document.dispatchEvent(new CustomEvent('el:cart-updated', { detail: c })); } catch (e) {}
  }
  function countBasket() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      refreshHeader(c);
      var a = 0, b = 0;
      return Promise.all((c.items || []).map(function (i) {
        var got = tagCache[i.handle] ? Promise.resolve(tagCache[i.handle]) :
          fetch('/products/' + i.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
            tagCache[i.handle] = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
            return tagCache[i.handle];
          });
        return got.then(function (tags) {
          if (tags.indexOf('tier-pricing') > -1) { a += i.quantity; if (tags.indexOf('autumn-sale-no10') === -1) b += i.quantity; }
        }).catch(function () {});
      })).then(function () { inCart = a; inCart10 = b; renderAll(); });
    }).catch(function () {});
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add to basket');
      return countBasket();
    });
  }
  function flash(card, button, text, ok) {
    var n = $('[data-el-nudge]', card);
    if (n) {
      n.dataset.lock = '1'; n.hidden = false;
      n.innerHTML = '';
      n.appendChild(document.createTextNode(text + ' '));
      if (ok) { var a = document.createElement('a'); a.href = '/cart'; a.textContent = 'View basket'; n.appendChild(a); }
      n.classList.toggle('is-error', !ok);
    }
    if (button && ok) { button.classList.add('is-done'); }
    setTimeout(function () {
      if (button) { button.classList.remove('is-done'); button.disabled = false; }
      if (n) { delete n.dataset.lock; n.classList.remove('is-error'); }
      render(card);
    }, 3500);
  }

  /* ---------- events (delegated, so cards added later by the theme also work) ---------- */
  document.addEventListener('click', function (e) {
    var size = e.target.closest('[data-el-size]');
    if (size) {
      var sb = size.closest('[data-el-card-body]'); if (!sb || size.disabled) return;
      var sp = +size.dataset.price, scmp = +size.dataset.compare, spcs = +size.dataset.pcs;
      sb.dataset.price = sp; sb.dataset.pcs = spcs;
      $$('[data-el-size]', sb).forEach(function (b) { var on = b === size; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var pack = $('[data-el-pack]', sb);
      if (pack && spcs > 0) setText(pack, (sb.dataset.unit === 'pack' ? 'Pack of ' : 'Case of ') + spcs);
      $$('[data-el-ladder] [data-min]', sb).forEach(function (r) {
        var el = $('.el-card__rung-price .el-money', r); if (el) setText(el, fmt(exv(rungInc(sp, +r.dataset.min))));
      });
      var was = $('.el-card__was', sb);
      if (was) { var wm = $('.el-money', was); if (scmp > sp) { was.hidden = false; if (wm) setText(wm, fmt(exv(scmp))); } else { was.hidden = true; } }
      var low = $('[data-el-low]', sb); if (low) low.hidden = size.dataset.low !== 'true';
      var sku = $('.el-card__sku', sb); if (sku && size.dataset.sku) setText(sku, size.dataset.sku);
      var sc = $('[data-el-card]', sb);
      if (sc) { sc.dataset.variant = size.dataset.id; sc.dataset.ex = exv(sp); render(sc); renderBar(); }
      return;
    }
    var step = e.target.closest('[data-el-step]');
    if (step) {
      var card = step.closest('[data-el-card]'); if (!card) return;
      var inp = $('[data-el-qty]', card);
      var min = isList(card) ? 0 : 1;
      inp.value = Math.min(999, Math.max(min, qtyOf(card) + parseInt(step.dataset.elStep, 10)));
      card.dataset.touched = '1';
      render(card); renderBar();
      return;
    }
    var add = e.target.closest('[data-el-add]');
    if (add) {
      var c = add.closest('[data-el-card]'); var q = qtyOf(c); if (q < 1) return;
      add.disabled = true;
      var lbl = $('[data-el-add-label]', c);
      addItems([{ id: +c.dataset.variant, quantity: q }]).then(function () {
        var qi = $('[data-el-qty]', c); if (qi && !isList(c)) qi.value = 1;
        c.dataset.touched = '1';
        if (lbl) lbl.textContent = 'Added';
        flash(c, add, 'Added ' + plural(q, c.dataset.unit || 'case') + '.', true);
      }).catch(function (err) { add.disabled = false; flash(c, null, err.message || 'Could not add - please try again.', false); });
      return;
    }
    var lid = e.target.closest('[data-el-lid]');
    if (lid) {
      var cl = lid.closest('[data-el-card]'); var ql = Math.max(1, qtyOf(cl));
      lid.disabled = true;
      addItems([{ id: +cl.dataset.lid, quantity: ql }]).then(function () {
        flash(cl, null, 'Added ' + plural(ql, 'case') + ' of the matching lid.', true);
        setTimeout(function () { lid.disabled = false; }, 3500);
      }).catch(function (err) { lid.disabled = false; flash(cl, null, err.message || 'Could not add - please try again.', false); });
      return;
    }
    var all = e.target.closest('[data-el-bar-add]');
    if (all) {
      var items = $$('.productgrid-listview [data-el-card]').filter(function (c) { return qtyOf(c) > 0; })
        .map(function (c) { return { id: +c.dataset.variant, quantity: qtyOf(c) }; });
      if (!items.length) return;
      all.disabled = true;
      var total = items.reduce(function (s, i) { return s + i.quantity; }, 0);
      addItems(items).then(function () {
        $$('.productgrid-listview [data-el-qty]').forEach(function (i) { i.value = 0; });
        renderAll();
        setBarMsg('Added ' + plural(total, 'case') + ' to your basket.', true);
      }).catch(function (err) { setBarMsg(err.message || 'Could not add - please try again.', false); })
        .then(function () { all.disabled = false; });
    }
  });
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-el-qty]')) return;
    var card = e.target.closest('[data-el-card]'); card.dataset.touched = '1'; render(card); renderBar();
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-el-qty]')) return;
    var card = e.target.closest('[data-el-card]');
    var min = isList(card) ? 0 : 1;
    e.target.value = Math.min(999, Math.max(min, parseInt(e.target.value, 10) || min));
    render(card); renderBar();
  });

  /* ---------- list view: quantities start at 0 and one bar adds everything ---------- */
  var bar = null, barMsgTimer = null;
  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'el-bar'; bar.hidden = true;
    bar.innerHTML = '<div class="el-bar__text"><b data-el-bar-sum></b><span data-el-bar-note></span></div>' +
      '<button type="button" class="el-bar__btn" data-el-bar-add>Add all to basket</button>';
    document.body.appendChild(bar);
    return bar;
  }
  function setBarMsg(t, ok) {
    ensureBar(); bar.hidden = false; bar.classList.add('is-msg');
    $('[data-el-bar-sum]', bar).textContent = t;
    $('[data-el-bar-note]', bar).innerHTML = ok ? '<a href="/cart">View basket</a>' : '';
    clearTimeout(barMsgTimer);
    barMsgTimer = setTimeout(function () { bar.classList.remove('is-msg'); renderBar(); }, 4000);
  }
  function renderBar() {
    var cards = $$('.productgrid-listview [data-el-card]');
    if (!cards.length) { if (bar) bar.hidden = true; return; }
    ensureBar();
    if (bar.classList.contains('is-msg')) return;
    var n = 0, nt = 0, ex = 0;
    cards.forEach(function (c) { var q = qtyOf(c); n += q; ex += q * (+c.dataset.ex); if (c.dataset.tier === 'true') nt += q; });
    bar.hidden = n < 1;
    if (n < 1) return;
    $('[data-el-bar-sum]', bar).textContent = plural(n, 'case') + ' selected · ' + fmt(ex) + ' ex VAT';
    var t = nt + inCart, note;
    if (nt === 0) note = 'Before any multi-case saving';
    else if (t < 3) note = 'Add ' + plural(3 - t, 'more case') + ' (any mix) to save 15%';
    else if (t < 10) note = '15% multi-case saving applies in your basket';
    else note = '19.25% multi-case saving applies in your basket';
    $('[data-el-bar-note]', bar).textContent = note;
  }
  function syncView() {
    $$('[data-el-card]').forEach(function (c) {
      var list = isList(c), inp = $('[data-el-qty]', c);
      if (!inp) return;
      if (list && c.dataset.view !== 'list') inp.value = 0;
      if (!list && c.dataset.view === 'list') inp.value = 1;
      c.dataset.view = list ? 'list' : 'grid';
      render(c);
    });
    renderBar();
  }
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { setTimeout(syncView, 0); });
    $$('.productgrid-gridview, .productgrid-listview').forEach(function (el) {
      mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
    var pending = false;
    new MutationObserver(function (m) {
      if (pending) return;
      for (var i = 0; i < m.length; i++) {
        for (var j = 0; j < m[i].addedNodes.length; j++) {
          var nd = m[i].addedNodes[j];
          if (nd.nodeType === 1 && (nd.matches('[data-el-card]:not([data-view])') || nd.querySelector('[data-el-card]:not([data-view])'))) {
            pending = true; setTimeout(function () { pending = false; syncView(); }, 50); return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  syncView();
  countBasket();
})();
